export const APP_NAME = 'gspt-assessments'